import React from 'react';
import PropTypes from 'prop-types';
import InputNav from './InputNav';
import Icon from './Icon';
import {Switch, Route, BrowserRouter as Router, Link} from 'react-router-dom';
import {
  Motion,
  StaggerdMotion,
  spring,
  translateX,
  TransitionMotion,
} from 'react-motion';
import {Row, Col} from 'reactstrap';
import Loader from 'react-loader';

import {Navbar, NavbarBrand, Nav, NavItem} from 'reactstrap';

const Header = props => {
  //Loading store show text instead of logo
  let logo =
    props.customStyle.logo && props.customStyle.logo.includes('missing') ? (
      <div />
    ) : (
      <img id="logo" src={props.customStyle.logo} />
    );
  if (!props.collections.length && props.body_style != 'html') {
    logo = <strong> LOADING STORE </strong>;
  }

  return (
    <header
      style={props.customStyle.header}
      className="container-fluid header-row">
      <div className="container">
        <div>
          <Row>
            <Col xs="12" md="4">
              <Route
                path="/"
                render={props_ => {
                  return (
                    <NavbarBrand
                      {...props_}
                      onClick={() => {
                        props_.history.push('/');
                      }}
                      style={{
                        color: props.customStyle.theme,
                        cursor: 'pointer',
                      }}>
                      {logo}
                    </NavbarBrand>
                  );
                }}
              />
              {!props.isMenuOpen && props.collections.length > 1 && (
                <div className="App__view-menu-wrapper">
                  <div
                    style={{
                      backgroundColor: 'clear',
                      color: props.customStyle.headerColor,
                    }}
                    onClick={props.menuClicked}>
                    {' '}
                    <Icon.FaMenuBarIcon />
                  </div>
                </div>
              )}
            </Col>
            <Col xs="12" md="4">
              <div>
                <Route
                  path="/"
                  render={props_ => (
                    <InputNav {...props_} update={props.searchClicked} />
                  )}
                />
              </div>{' '}
            </Col>
            <Col md="4">
              {!props.isCartOpen && (
                <div className="App__view-cart-wrapper">
                  <div
                    style={{
                      backgroundColor: 'clear',
                      color: props.customStyle.headerColor,
                    }}
                    onClick={props.cartClicked}>
                    {' '}
                    <Icon.FaCartIcon />
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  customStyle: PropTypes.object.isRequired,
  isMenuOpen: PropTypes.bool.isRequired,
  collections: PropTypes.array.isRequired,
  isCartOpen: PropTypes.bool.isRequired,
  searchClicked: PropTypes.func.isRequired,
  menuClicked: PropTypes.func.isRequired,
  cartClicked: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js